import * as React from 'react';
import { ThemeContext } from 'react-fela';
import type { GlobalTheme } from 'types';

type Props = React.SVGProps<SVGSVGElement>;

export default function AddProfileIcon(props: Props): JSX.Element {
  const { width = '12rem', height = '12rem', ...rest } = props;
  const theme = React.useContext(ThemeContext) as GlobalTheme | null;
  const circleFill = theme?.color?.whiteButtonBackground;
  const iconFill = theme?.color?.iconLightFill;

  return (
    <svg width={width} height={height} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <circle cx="100" cy="100" r="100" fill={circleFill}/>
      <path d="M95.6055 106.076H62.5802C61.1024 106.076 59.8542 105.558 58.8353 104.523C57.8165 103.487 57.3071 102.251 57.3071 100.815C57.3071 99.3781 57.8165 98.1553 58.8353 97.1463C59.8542 96.1374 61.1024 95.6329 62.5802 95.6329H95.6055V62.6076C95.6055 61.1676 96.1163 59.9288 97.1379 58.8911C98.1595 57.8534 99.3784 57.3345 100.795 57.3345C102.211 57.3345 103.44 57.8534 104.484 58.8911C105.527 59.9288 106.048 61.1676 106.048 62.6076V95.6329H139.074C140.485 95.6329 141.699 96.1443 142.717 97.1672C143.735 98.1899 144.244 99.4196 144.244 100.856C144.244 102.293 143.735 103.522 142.717 104.544C141.699 105.565 140.485 106.076 139.074 106.076H106.048V139.101C106.048 140.512 105.528 141.726 104.486 142.744C103.444 143.762 102.201 144.271 100.755 144.271C99.338 144.271 98.1257 143.762 97.1177 142.744C96.1096 141.726 95.6055 140.512 95.6055 139.101V106.076Z" fill={iconFill}/>
    </svg>
  );
}

